import { Component } from '@angular/core';
import { map } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { environment } from 'src/environments/environment';
import { PdvSelectors } from 'src/app/store/pdv/selectors';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  enableSolutionsLink = environment.enableSolutionsLink;
  faqUrl = environment.faqUrl;
  address = environment.address;

  logo$ = this.store.pipe(
    select(PdvSelectors.selectCompany),
    map(function(company) { 
      if (document.location.host.replace('www.', '').replace("dev", "").startsWith("ingressosa.com")) {
        return "https://static-meubilhete.s3.dualstack.us-east-1.amazonaws.com/company/e383fdc4-9045-457e-af90-fc4e3b311333-company-logosite.png"
      } else {      
        return company?.images?.logosite ?? '' 
      }
    })
  );


  configs$ = this.store.pipe(select(PdvSelectors.selectPdvConfigs));

  constructor(private store: Store) {}
}
